<script lang="ts">
    import { DRAWER_POSITION } from "@/constants/drawer";
    import { LEFT_RIGHT, RIGHT_LEFT, swipeable } from "@ui-utils/SwipeObserver";
    import CN from "classnames";

    import DrawerBackdrop from "./DrawerBackdrop.svelte";
    import DrawerManager from "./DrawerManager";

    export let drawerClass: string | null = null;
    export let direction: DRAWER_POSITION;
    export let drawerManager: DrawerManager;
    const visible$ = drawerManager.visible$;
    let shift: null | number = null;
    let defaultBodyOverflow: string;
    const handleCloseDrawer = () => {
        drawerManager.drawerHide();
    };
    const handleSwipe = () => {
        handleCloseDrawer();
    };
    const handleShift = (v: number | null) => {
        shift = v;
    };

    $: {
        if ($visible$) {
            defaultBodyOverflow = document.body.style.overflow;
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = defaultBodyOverflow;
        }
    }
</script>

<div
    class={CN("gw-drawer", drawerClass, `gw-drawer--${direction}`, {
        "gw-drawer--open": $visible$,
    })}
>
    {#if $visible$}
        <DrawerBackdrop on:click={handleCloseDrawer} />
    {/if}
    <slot />
    <div
        use:swipeable={{
            direction:
                direction === DRAWER_POSITION.RC ? LEFT_RIGHT : RIGHT_LEFT,
            tolerance: 99,
            onSwipe: handleSwipe,
            onShift: handleShift,
        }}
        class={`gw-drawer__sidebar gw-drawer__sidebar--${direction}`}
        class:gw-drawer__sidebar--draggable={shift}
        class:gw-drawer__sidebar--opened={$visible$}
    >
        <slot name="sidebar" />
    </div>
</div>

<style>
    .gw-drawer {
        position: fixed;
        top: 0;
        height: 100%;
    }

    .gw-drawer--open {
        z-index: var(--gw-z-index-drawer);
    }

    .gw-drawer--RC {
        right: 0;
    }

    .gw-drawer--LC {
        left: 0;
    }

    .gw-drawer__sidebar {
        position: fixed;
        z-index: 2;
        top: 0;
        width: var(--gw-drawer-sidebar-width);
        height: 100%;
        backface-visibility: hidden;
        transition: transform var(--gw-default-transition);
        background-color: var(--gw-drawer-sidebar-bg);
    }

    .gw-drawer__sidebar--LC {
        left: 0;
        transform: translateX(-100%) translateZ(0);
    }

    .gw-drawer__sidebar--RC {
        right: 0;
        transform: translateX(100%) translateZ(0);
    }

    .gw-drawer__sidebar.gw-drawer__sidebar--opened {
        transform: translateX(0) translateZ(0);
    }

    .gw-drawer__sidebar.gw-drawer__sidebar--draggable {
        transition: transform 0;
        cursor: grab;
    }
</style>
